module.exports = __webpack_public_path__ + "static/media/25.04c9a562.jpeg";